/**
 * @author Daniel Aguirre
 * @file actions.js
 * @description PatientEvent Actions
 */

// Constants
import {
  GET_ALL_PATIENT_EVENTS,
  CREATE_PATIENT_EVENT,
  UPDATE_PATIENT_EVENT,
  GET_PATIENT_EVENT_BY_ID,
  DELETE_PATIENT_EVENT_BY_ID,
  GET_ALL_EVENT_TYPES
} from './constants';

/**
 * Call process to get all patients list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_ALL_PATIENT_EVENTS
 */
export const getPatientEventsArray = (data, callback) => ({
  type: GET_ALL_PATIENT_EVENTS,
  payload: { data },
  callback
});

/**
 * Call process to get patient by id
 * @param  { object } data - PatientEvent Id
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_ROL_BY_ID
 */
export const getPatientEventById = (data, callback) => ({
  type: GET_PATIENT_EVENT_BY_ID,
  payload: { data },
  callback
});

/**
 * Call process to create patient
 * @param  { object } data - PatientEvent Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of CREATE_PATIENT_EVENT
 */
export const createPatientEvent = (data, callback) => ({
  type: CREATE_PATIENT_EVENT,
  payload: { data },
  callback
});

/**
 * Call process to update patient
 * @param  { object } data - PatientEvent Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of UPDATE_PATIENT_EVENT
 */
export const updatePatientEvent = (data, callback) => ({
  type: UPDATE_PATIENT_EVENT,
  payload: { data },
  callback
});

/**
 * Call process to delete patient
 * @param  { object } data - PatientEvent Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of DELETE_PATIENT_EVENT_BY_ID
 */
export const deletePatientEventById = (data, callback) => ({
  type: DELETE_PATIENT_EVENT_BY_ID,
  payload: { data },
  callback
});

/**
 * Call process to get all event types list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_ALL_PATIENT_EVENTS
 */
export const getEventTypesArray = (data, callback) => ({
  type: GET_ALL_EVENT_TYPES,
  payload: { data },
  callback
});
